import React from "react";
import PropTypes from "prop-types";
import sortBy from "lodash/sortBy";
import filter from "lodash/filter";
import cx from "classnames";

import boxStates from "../../../utils/boxStates";

import env from "../../../utils/env";

import "./Box.css";
import BoxImage from "./img-mystery-box.svg";

const mysteryBoxUrl = `${env.cfURL}/static/media/${env.mysteryBoxFilename}`;

const Box = props => {
  const getLatestBox = boxes => {
    const shipped = filter(boxes, box => {
      return box.shipDate;
    });

    const ordered = sortBy(shipped, box => {
      const unixShipTime = new Date(box.shipDate).getTime() / 1000;
      return unixShipTime;
    }).reverse();

    return ordered[0];
  };

  const { boxData, isMobile, isEligible, rateMyBoxLinkOnMyBoxFlag, surveyStarted } = props || {};
  const { currentBox, shiplist } = boxData || {};
  const { name, imageUrl, boxStatus } =
    currentBox || getLatestBox(shiplist) || {};

  const validBoxStatus = status => {
    if (!status) {
      return false;
    }

    if (
      status === boxStates.DELIVERED || 
      status === boxStates.PROB_DELIVERED ||
      status === boxStates.SHIPPED) {
      return true;
    }

    return false;
  };

  const validImageUrl = imageUrl => imageUrl && imageUrl.length;

  const boxImageUrl =
    validImageUrl(imageUrl) && validBoxStatus(boxStatus)
      ? imageUrl
      : mysteryBoxUrl;

  const reviewUrl = `${env.envURL}/rate-my-box`;

  const reviewButton = rateMyBoxLinkOnMyBoxFlag ? (
    <button
      className="ratings-and-review-link"
      onClick={() => window.open(reviewUrl, '_self')}
    >
      <i className="fal fa-star"></i>Review My Box
    </button>
  ) : '';

  const boxTitleStyle = cx({
    "mar-0": !isMobile,
    "mar-h-8": isMobile,
    "ff-ns": true,
    "fs-16": true
  });

  return (
    <div className="box ta-center pad-8">
      <img className="my-box-image" src={boxImageUrl} alt={name} />
      <p className={boxTitleStyle}>{name}</p>
      { isEligible && !surveyStarted ? reviewButton : '' }
    </div>
  );
};

export default Box;

Box.defaultProps = {
  name: "",
  rateMyBoxLinkOnMyBoxFlag: false,
  isEligible: false,
  surveyStarted: false,
};

Box.propTypes = {
  name: PropTypes.string,
  boxImageUrl: PropTypes.string,
  rateMyBoxLinkOnMyBoxFlag: PropTypes.bool,
  isEligible: PropTypes.bool,
  surveyStarted: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/Components/Header/Box/Box.js